export default __webpack_public_path__ + "images/syc2_8118a1.svg";